export const LOGISTICS_PERMISSIONS = {
  CUSTOMER_DELIVERY: {
    MODULE_NAME: 'Customer Delivery',
    'View': 'customerdelivery_view',
    'ATW Add/Edit': 'customerdelivery_crud_atw',
    'Add/Edit Details': 'customerdelivery_crud_details',
    'Cancel Transaction': 'customerdelivery_cancel',
    'Cancel Transaction with Details': 'customerdelivery_cancel_with_details',
    'Verify ATW': 'atw_verify',
    'Trade Approver': 'atw_trade_approver'
  },
  DELIVERY_REPORT: {
    MODULE_NAME: 'Delivery Report',
    'Generate Delivery Report': 'deliveryreport_view'
  },
  SUPPLIER_MONITORING: {
    MODULE_NAME: 'Supplier Monitoring',
    'View': 'suppliermonitoring_view',
    'Add/Edit': 'suppliermonitoring_crud',
    'Cancel Transaction': 'suppliermonitoring_cancel'
  },
  INTERPLANT_TRANSFER_ATL: {
    MODULE_NAME: 'Inter Plant Transfer - ATL',
    'View': 'itpn_atl_view',
    'Add/Edit': 'itpn_atl_add_edit',
    'Cancel Transaction': 'itpn_atl_cancel',
    'Verify Transaction': 'itpn_atl_verify',
  },
  MANUAL_ADJUSTMENTS: {
    MODULE_NAME: 'Manual Adjustments',
    'Manual Adjustment': 'manual_adjustments'
  },
  MAINTENANCE: {
    MODULE_NAME: 'Maintenance',
    Seal: 'maintenance_seal',
    Source: 'maintenance_source'

  }

}